/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutBottombarExpand = createReactComponent("outline", "layout-bottombar-expand", "IconLayoutBottombarExpand", [["path", { "d": "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z", "key": "svg-0" }], ["path", { "d": "M20 15h-16", "key": "svg-1" }], ["path", { "d": "M14 10l-2 -2l-2 2", "key": "svg-2" }]]);

export { IconLayoutBottombarExpand as default };
//# sourceMappingURL=IconLayoutBottombarExpand.mjs.map
